import React, { Component } from 'react';
import { KeyboardArrowDown, KeyboardArrowRight } from "@mui/icons-material";
import CircularProgress from '@mui/material/CircularProgress';
import {
    Table,
    TableBody,
    TableCell,
    TableSortLabel,
    TableContainer,
    TableHead,
    Paper,
    TableRow,
    TablePagination
} from "@mui/material";
import Pagination from '@mui/material/Pagination';
import IconButton from '@mui/material/IconButton';
import ArrowLeft from '@mui/icons-material/ArrowLeft';
import ArrowRight from '@mui/icons-material/ArrowRight';
import CommonIcon from '../helpers/icons';

class SubscriptionListViewTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasVerticalScrollbar: false,
            page: Number(this.props.currentPage),
            rowsPerPage: Number(this.props.pagesize),
            
        }
        

        this.tableRef = React.createRef();
        this.scrollTimeout = null;
        this.handleScroll = this.handleScroll.bind(this);
    }


    componentDidMount() {
        this.tableRef.current.addEventListener('scroll', this.handleScroll);
        console.log(this.state.page, this.state.rowsPerPage, 'pagein sub');

    }

    handleScroll() {
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            const table = this.tableRef.current;
            if (this.tableRef.current.scrollTop + this.tableRef.current.clientHeight >= table.scrollHeight - 50) {
                this.props.handleScroll()
            }
        }, 200);

    }
    componentDidUpdate
        (prevProps) {

           
        if (this.tableRef.current) {
            const element = this.tableRef.current;
            const hasVerticalScrollbar = element.scrollHeight > element.clientHeight;
            if (this.state.hasVerticalScrollbar !== hasVerticalScrollbar) {
                this.setState({ hasVerticalScrollbar });
            }
        }
        if (prevProps.pagesize !== this.props.pagesize) {

            this.setState({ rowsPerPage: Number(this.props.pagesize) });
        }
    
        if (prevProps.currentPage !== this.props.currentPage) {
            
            this.setState({page:Number(this.props.currentPage)});
        }
    }
    formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'short' }); // e.g., 'Jul'
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';

        const formattedHours = hours % 12 || 12;
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        return `${day} ${month} ${year} ${formattedHours}:${formattedMinutes} ${ampm}`;
    };
    formatDateOnly = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'short' }); // e.g., 'Jul'
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';

        const formattedHours = hours % 12 || 12;
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        return `${day} ${month} ${year} `;
    };

    formatDatemonth = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'short' }); // e.g., 'Jul'
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';

        const formattedHours = hours % 12 || 12;
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        return `${day} ${month}`;
    };




    handleChangePage = (event, newPage) => {
        
        const zeroBasedPage = newPage
        this.setState({ page: zeroBasedPage }, () => {
            this.props.paginatedData(zeroBasedPage);
        });
    };
    handleChangeRowsPerPage = (event) => {
        
        const newRowsPerPage = parseInt(event.target.value, 10);
        const newPageCount = Math.ceil(this.props.totalcount / newRowsPerPage);
        const newPage = this.props.currentPage 

        this.setState({
            rowsPerPage: newRowsPerPage,
            page: newPageCount, 
        }, () => {
            this.props.rowPerPage(newRowsPerPage);
            this.props.paginatedData(newPage); 
        });
    };


    render() {
        const columnHeaders = this.props?.columns;
        const sortConfig = this.props?.sortConfig;
        const groupedData = this.props?.data || [];
        const normalData = this.props?.value || [];
        const collapsedGroups = this.props?.collapsedGroups || {};
        const groupedName = this.props?.groupedName;
        const isLoader = this.props?.isLoader;
        const totalcount = this.props.totalcount;
        const { page, rowsPerPage } = this.state;
        const paginatedData = normalData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
        const pageCount = Math.ceil(normalData.length / rowsPerPage);
        // console.log(sortConfig);
        

        // console.log(Math.ceil(normalData.length / rowsPerPage));


        return (
            <div className='table-wrapper1'>
                <TableContainer component={Paper} className={`table_change removeborder plr mr-scroll mb-3`} sx={{ marginTop: 2 }} ref={this.tableRef}>
                    <Table className={`tableborder table-wid-2 ${this.state.hasVerticalScrollbar ? "normalwidth" : "scrolerwidth"}`} stickyHeader aria-label="sticky table">
                        <TableHead sx={{ position: "sticky", top: 0, zIndex: 1, "& .MuiTableCell-root": { backgroundColor: "background.paper" }, }}>
                            <TableRow className="tabel-head">
                                {columnHeaders.map((column) => (
                                    <TableCell className="table-header-padding" key={column.key} size='small'>
                                        <TableSortLabel
                                            className="table_label"
                                            active={sortConfig.sortBy === column.key}
                                            direction={
                                                sortConfig.sortByOrder || sortConfig.sortByhistory
                                            }
                                            onClick={() => this.props?.handleSort(column.key)}
                                        >
                                            {column.label}
                                        </TableSortLabel>
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                       
                            {isLoader ?
                                <TableRow>
                                    <TableCell colSpan={columnHeaders.length + 1} className="group-header mt-3 text-center" align="center">
                                        <CircularProgress color="primary" className="text-center" />
                                    </TableCell>
                                </TableRow>
                                : (normalData.length > 0) ? (
                                    normalData.map((row) => (
                                        <TableRow key={row.id}>
                                            {columnHeaders.map((column) => (
                                                <TableCell className="table-cell-padding" key={column.key}>
                                                    {column.key === "name" ? (
                                                        <span className=''>
                                                            {row[column.key] === null ? "-" : row[column.key]}
                                                        </span>
                                                    ) : (
                                                        column.key === "subcriptionStatus" ? (
                                                            row[column.key] === "Subscribed" ? (
                                                                <span style={{ color: "#00B83F" }}>Subscribed</span>
                                                            ) : (
                                                                row[column.key] === "Not Subscribed" ? (
                                                                    <span style={{ color: "grey" }}>Unsubscribed</span>
                                                                ) : (
                                                                    <span style={{ color: "red" }}></span>
                                                                )
                                                            )
                                                        ) : (
                                                            column.key === "remove" ? (
                                                                <span onClick={() => { this.props.handleDelete(row) }} className='cursor-pointer'><CommonIcon fileName={'DeleteIcon'} /></span>
                                                            ) : column.key === "actionDate" ? (
                                                                <span>{this.formatDate(row.actionDate)}</span>
                                                            ) : (
                                                                column.key === "isPurchased" ? (
                                                                    <span className='table-link' onClick={() => this.props.handleChangeId(row.applicationId)}>
                                                                        {row.isPurchased ? (
                                                                            <button className='btn btn-fun' disabled>Purchased</button>
                                                                        ) : (
                                                                            <button className='btn btn-fun'>Purchase</button>
                                                                        )}
                                                                    </span>
                                                                ) :
                                                                (column.key=="totalAmount")?
                                                                    <span className=''>{row.currencySymbol+" "+row[column.key]}</span>:
                                                                (column.key=="InvoiceNo")?
                                                                    <span className='table-link' onClick={()=>{this.props.handleInvoiceEdit(row.invoiceId)}}>{row.invoiceNumber}</span>:
                                                                    
                                                                    (column.key=="cost")?
                                                                    <span className=''>{this.props.currencySymbol+ row[column.key]}</span>:
                                                                    (column.key=="InvoiceDate")?
                                                                    <span className=''>{this.formatDateOnly(row.invoiceDate)}</span>:
                                                                    (column.key=="amount")?
                                                                    <span className=''>{this.props.currencySymbol+ row[column.key]}</span>:
                                                                    (column.key=="interval")?
                                                                    <span className=''>{this.formatDatemonth(row.billingFromDate)+"-"+this.formatDatemonth(row.billingToDate) }</span>:
                                                                    (column.key=="actiondownload")?
                                                                    <span className='cursor-pointer' onClick={()=>this.props.downloadPdf(row.invoiceUrl)}><CommonIcon fileName={'downloadbill'}/></span>:
                                                                    column.key === "status" ? (
                                                                        row[column.key] === "Paid" ? (
                                                                            <span style={{ color: "#00B83F" }}>Paid</span>
                                                                        ) : (
                                                                            row[column.key] === "Pending" ? (
                                                                                <span style={{ color: "#FFB100" }}>Pending</span>
                                                                            ) : (
                                                                                <span style={{ color: "red" }}>Due</span>
                                                                            )
                                                                        )
                                                                    ):
                                                                 (
                                                                    row[column.key]
                                                                )
                                                            )
                                                        ))}
                                                </TableCell>
                                                
                                            ))}
                                        </TableRow>
                                    ))
                                ) : (
                                    (normalData.length === 1 || isLoader) ? (
                                        <TableRow>
                                            <TableCell colSpan={columnHeaders.length + 1} className="group-header mt-3 text-center" align="center">
                                                <CircularProgress color="primary" className="text-center" />
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        <TableRow className='border-no'>
                                            <TableCell colSpan={columnHeaders.length + 1} className="group-header mt-3 text-center" align="center">
                                                No records to display
                                            </TableCell>
                                        </TableRow>
                                    )
                                )}
                        </TableBody>
                    </Table>
                </TableContainer>
                {this.state.hasVerticalScrollbar && (
                    <div className="border-bottom"></div>
                )}
                {!this.props.invoice?
                
                <div className="pagination-container">
                    {/* Rows per page selector */}
                    <div className="rows-per-page">
                        <select
                            value={rowsPerPage}
                            onChange={this.handleChangeRowsPerPage}
                            style={{ fontSize: '14px', padding: '4px', outline: 'none', border: '1px solid #e8e8e8' }}
                        >
                            {[1,2, 5, 10, 25].map(size => (
                                <option key={size} value={size}>
                                    {size}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Pagination controls */}

                    <div className="pagination-controls">


                        <Pagination


                            count={this.props.totalpages} // Total pages
                            page={this.props.currentPage} // 1-based page number
                            onChange={this.handleChangePage}
                            siblingCount={0} // Adjust as needed
                            boundaryCount={1} // Show boundary pages
                            shape="rounded"
                        />

                    </div>

                </div>
                :""}

            </div>
        );
    }

}

export default SubscriptionListViewTable;
